import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner, Box } from '@chakra-ui/react';
import { User } from '@supabase/supabase-js';

interface ProtectedRouteProps {
  children: ReactNode;
  user: User | null;
  redirectTo?: string;
}

export function ProtectedRoute({ 
  children, 
  user, 
  redirectTo = '/login' 
}: ProtectedRouteProps) {
  const location = useLocation();

  // If user is still being determined, show loading spinner
  if (user === undefined) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minH="100vh">
        <Spinner size="xl" />
      </Box>
    );
  }

  // If user is not authenticated, redirect to login
  if (!user) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
